<template>
    <!-- 司机-优享券-添加 -->
    <el-drawer title="添加" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px" destroy-on-close>
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="130px" style="height: 90vh; overflow-y: auto">
                 

                    <el-form-item label="优享券名称:">
                        <el-input
                            v-model="submit_data.name"
                            :placeholder="submit_rules.name.placeholder"
                            style="width: 150px; margin-right: 5px"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="有效期（天）:">
                        <el-input
                            v-model="submit_data.expiration"
                            :placeholder="submit_rules.expiration.placeholder"
                            style="width: 150px; margin-right: 5px"
                        >
                        </el-input> 
                        <span class="tishi">注：有效期自发放日开始计算</span>
                    </el-form-item>
                   
                    <el-form-item label="创建数量:">
                        <el-input
                            v-model="submit_data.num"
                            :placeholder="submit_rules.num.placeholder"
                            style="width: 150px; margin-right: 5px"
                        >
                        </el-input>
                    </el-form-item>
                    
                    
                </el-form>

                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center; margin-top: 20px">
                    <submitBtn
                        @onSubmitDig="onSubmitDig"
                        :data="submit_data"
                        :rules="submit_rules"
                        :url="submit_url"
                        :JSON_Boolean="false"
                    ></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-drawer>
</template>

<script>
var _this;

export default {
    components: {
       
    },
    props: {
        isShow: Boolean
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
          
        }
    },
    data() {
        return {
          
            show: false,
            submit_url: '/priority/addPrioritySubmit',
            // 表单数据
            submit_data: {
                name: '',
                expiration: '',
                num: ''
            },

            submit_rules: {
                name: {
                    placeholder: '优享券名称',
                    rules: {
                        required: true,
                        message: '优享券名称30个字以内',
                        regulation: 'between_str',
                        rulesData: [1, 30]
                    }
                },
                expiration: {
                    placeholder: '有效期',
                    rules: {
                        required: true,
                        message: '有效期不正确',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                num: {
                    placeholder: '创建数量',
                    rules: {
                        required: true,
                        message: '创建数量不正确',
                        regulation: 'egt',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
  
    methods: {
      
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.submit_data = {
                name: '',
                expiration: '',
                num: ''
            };
        },

        onSubmitDig() {
            _this.$emit('onSubmit');
            _this.closeDialog();
        }
    }
};
</script>

<style scoped>

.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}
.tishi {
    color: red;
    font-size: 14px;
    display: block;
    text-indent: -30px;
}


</style>
